module.exports = (__webpack_require__(4))(1803);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/perfect-scrollbar/dist/perfect-scrollbar.esm.js from dll-reference vendorProd_library
// module id = 695
// module chunks = 42